import { withProfiler } from "@sentry/react";
import { StrictMode } from "react";

import { LazyHotReloadIndicator } from "@shared/components/LazyHotReloadIndicator/LazyHotReloadIndicator";
import { LazyReactAxe } from "@shared/components/LazyReactAxe/LazyReactAxe";
import { Router } from "@shared/components/Router/Router";
import type { Flipper } from "@shared/types/flipper";
import { ErrorBoundary } from "@unauthenticated/signupSignin/components/ErrorBoundary/ErrorBoundary";
import { Providers } from "@unauthenticated/signupSignin/components/Providers/Providers";
import { OfficeResendInvitationPage as OfficeResendInvitationScene } from "@unauthenticated/signupSignin/scenes/OfficeResendInvitationPage/OfficeResendInvitationPage";

interface Props {
  storeAttributes: {
    storeId: string;
    storeName: string;
    storeLogo: string;
  };
  analyticsAnonymousId: string;
  e2e: boolean;
  currentCountry: string;
  flippers: Flipper[];
}

const OfficeResendInvitationPage = ({
  storeAttributes,
  currentCountry,
  e2e,
  analyticsAnonymousId,
  flippers,
}: Props) => {
  return (
    <StrictMode>
      <Router>
        <Providers
          currentCountry={currentCountry}
          flippers={flippers}
          e2e={e2e}
          analyticsAnonymousId={analyticsAnonymousId}
        >
          <ErrorBoundary {...{ flippers }}>
            <OfficeResendInvitationScene storeAttributes={storeAttributes} />
          </ErrorBoundary>
        </Providers>
        <LazyHotReloadIndicator />
        <LazyReactAxe />
      </Router>
    </StrictMode>
  );
};

const PatientInvitationPageWithProfiler = withProfiler(OfficeResendInvitationPage);
export { PatientInvitationPageWithProfiler as OfficeResendInvitationPage };
